export {
  default,
  configure,
  toast,
  triggerPrint
} from './Page'
